import {isStringFalse} from "@Common/logic/is-string-false";

export const isXdQaNoPopup = () => !isStringFalse( localStorage.XD_QA_NO_POPUP );
